import React from 'react'
import "./section.css";

const BottomSection = () => {
    return( 
    <div id = "bottom-sec-text">
        <h4>Deforestation</h4>
        <p>
             Deforestation is the clearing of large amounts of trees. 
             This act has been greatly accelerated by human activities since the past century. 
             Deforestation affects ecosystems, biodiversity, and the climate. 
             This must be stopped for the preservation and conservation of trees. 
          
        </p>
    </div>
     
    )
}

  

export default BottomSection;


